import { FormControl } from '@angular/forms';

export class MultiSelect {
    values: Array<any> = [];
    selectedValuesObj: FormControl = new FormControl();
    oldSelectedValues?: Array<any> = [];
    multiSelectEvents?: MultiSelectEvents;
    isMultiselectChanged?: boolean;

    constructor() { }
}

export class MultiSelectEvents {
    onSelectionChange?: Function;

    constructor() { }
}